"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.confirmLoginErrorMessage = void 0;
exports.confirmLoginErrorMessage = "Since this is the first time you are logging from this device, we have sent you an email to confirm it's you. Follow the instructions in the email to log in.";
//# sourceMappingURL=login_helper.js.map